import { TourProvider as ReactourProvider, StylesObj } from '@reactour/tour'
import { ReactNode } from 'react'

const tourStyles = {
  popover: (base: StylesObj) => ({
    ...base,
    borderRadius: '6px',
    padding: '18px',
    transition: 'none',
  }),
  maskArea: (base: StylesObj) => ({
    ...base,
    rx: 8,
  }),
  close: (base: StylesObj) => ({
    ...base,
    position: 'absolute' as const,
    right: '10px',
    top: '10px',
  }),
}

const TourProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ReactourProvider
      showBadge={false}
      showDots={false}
      showNavigation={false}
      steps={[]}
      styles={tourStyles}
    >
      {children}
    </ReactourProvider>
  )
}

export default TourProvider
